import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LookupService } from "../lookup.service"
import { lookupsLoad, lookupsLoadedFromApi, lookupsLoadedFromApiFailed } from "../reducers/lookup.reducer";
import { catchError, exhaustMap, forkJoin, map, of } from "rxjs";
import { LookupType } from "../models";

@Injectable()
/**
 * ngrx side effect for the lookups store. On `lookupsLoad`, fetches all static
 * lookup sets (gender, race, store type, province, relationships, field agents,
 * mobile networks, banks, claim verification/approval users) in parallel and
 * dispatches the combined result (or failure) to the lookup reducer.
 */
export class LookupEffects {
    private actions$ = inject(Actions);
    private lookupService = inject(LookupService);

    /** Effect: loads all lookup sets from the API and dispatches loaded/failed. */
    loadLookups$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(lookupsLoad.type),
            exhaustMap(() => forkJoin([
                this.lookupService.getLookups(LookupType.Gender),
                this.lookupService.getLookups(LookupType.Race),
                this.lookupService.getLookups(LookupType.StoreType),
                this.lookupService.getLookups(LookupType.Province),
                this.lookupService.getLookups(LookupType.NextOfKinRelationship),
                this.lookupService.getLookups(LookupType.FieldAgent),
                this.lookupService.getLookups(LookupType.MobileNetwork),
                this.lookupService.getLookups(LookupType.Bank),
                this.lookupService.getLookups(LookupType.ClaimVerificationUsers),
                this.lookupService.getLookups(LookupType.ClaimApprovalUsers)
            ]).pipe(
                map(([
                        gender, 
                        race, 
                        storeType, 
                        province, 
                        nextOfKinRelationship, 
                        fieldAgent, 
                        mobileNetwork,
                        bank,
                        claimVerificationUsers,
                        claimApprovalUsers
                    ]) => ({  
                        type: lookupsLoadedFromApi.type, 
                        lookups: 
                        { 
                            gender,  
                            race, 
                            storeType, 
                            province, 
                            nextOfKinRelationship, 
                            fieldAgent, 
                            mobileNetwork,
                            bank,
                            claimVerificationUsers,
                            claimApprovalUsers
                        }
                    })
                ),
                catchError(() => of({ type: lookupsLoadedFromApiFailed.type }))
            )
        ))
    });
}